export default __webpack_public_path__ + "static/media/Crib.e82d42bc.jpeg";